import type { NavItem } from '../types';

export const NAV_ITEMS: NavItem[] = [
  {
    name: 'How it Works',
    href: '#how-it-works',
  },
  {
    name: 'For Hospitals',
    href: '#for-hospitals',
  },
  {
    name: 'For Suppliers',
    href: '#for-suppliers',
  },
];

export const SOCIAL_LINKS = {
  linkedin: 'https://linkedin.com/company/medalt',
  twitter: 'https://twitter.com/medalt',
  email: 'contact@medalt.com',
} as const;

export const COMPANY_INFO = {
  name: 'MedAlt',
  tagline: 'Find Clinician-Approved Alternatives — Instantly',
  description: 'AI powered platform that connects hospitals to safe, in-stock medical device substitutes with real-time clinical and supplier insights.',
  founded: '2024',
  location: 'United States',
} as const; 